export enum Settings {
  TeagleMapLabelVehicleSize = 'TEAGLE-MAPLABELVEHICLESIZE',
  TeagleVehicleAddressSize = 'TEAGLE-VEHICLEADDRESSSIZE',
  TeagleLiveDataRefresh = 'TEAGLE-LIVEDATAREFRESH',
  TeagleVehiclesGroupView = 'TEAGLE-VEHICLESGROUPVIEW',
  TeagleMapClustering = 'Teagle-Map-Clustering',
  TeagleMapClusteringRadius = 'Teagle-Map-Clustering-Radius',
  TeagleCoordinateType = 'TEAGLE-COORDINATE-TYPE',
  TeagleVehiclesLimitHistory = 'TEAGLE-VEHICLES-LIMIT-HISTORY',
  TeaglePasswordPolicy = 'Teagle-Password-Policy',
}
